import ExtensionService from "../../../../service/ExtensionService";
import MethodService from "../../../../service/MethodService";
import DocumentApi from "../../../../moduleApi/DocumentApi";
import DocumentCategoryApi from "../../../../moduleApi/DocumentCategoryApi";
import DocumentBusinessApi from "../../../../moduleApi/DocumentBusinessApi";
import DocumentGroupApi from "../../../../moduleApi/DocumentGroupApi";
import BookApi from "../../../../moduleApi/BookApi";
import EmployeeApi from "../../../../moduleApi/EmployeeApi";
import PositionApi from "../../../../moduleApi/PositionApi";
import BranchApi from "../../../../moduleApi/BranchApi";
import DepartmentApi from "../../../../moduleApi/DepartmentApi";
import OrganizationModelApi from "../../../../moduleApi/OrganizationModelApi";
import CompanySignApi from "../../../../moduleApi/CompanySignApi";
import SignRequestHistoryApi from "../../../../moduleApi/SignRequestHistoryApi";
import TransferHistoryApi from "../../../../moduleApi/TransferHistoryApi";
import PublishHistoryApi from "../../../../moduleApi/PublishHistoryApi";
import TempSignRequestHistoryApi from "../../../../moduleApi/TempSignRequestHistoryApi";
import ContractTypeApi from "../../../../moduleApi/ContractTypeApi";
import ContractTemplateCategoryApi from "../../../../moduleApi/ContractTemplateCategoryApi";
import EventBus from '../../../../service/EventBus'
import _ from 'lodash'

export const fnDocMixins = {
  methods: {
    async fn_getListConTractType() {
      const contractTypeApiRes = await ContractTypeApi.list({
        filters: "disabled=false",
        fields: "id,disabled",
        limit: 9999,
      });
      if (contractTypeApiRes.result && contractTypeApiRes.result.length > 0) {
        this.mData.dataDefault.listContractTypeId = []
        contractTypeApiRes.result.forEach(contract => {
          if (!contract.disabled) this.mData.dataDefault.listContractTypeId.push(contract.id);
        });
      }
    },

    async fn_getListEmployee() {
      const employeeApiRes = await EmployeeApi.list({
        filters: "disabled=false" + "&status=DANG_LAM_VIEC",
        limit: 9999,
      });
      if (employeeApiRes.result && employeeApiRes.result.length > 0) {
        this.mData.dataDefault.listEmployee = employeeApiRes.result;
      }
    },

    async fn_getListAllEmployee() {
      const employeeApiRes = await EmployeeApi.list({
        limit: 9999,
      });
      if (employeeApiRes.result && employeeApiRes.result.length > 0) {
        this.mData.dataDefault.listAllEmployee = employeeApiRes.result;
      }
    },

    fn_setLabelRespectively(item) {
      return `${item.employee_no ? item.employee_no : ''} - ${item.administrative_info.name.full_name ? item.administrative_info.name.full_name : ''}`;
    },

    async fn_getListPosition() {
      const positionApiRes = await PositionApi.list({
        fields: 'name',
        limit: 9999
      });
      if (positionApiRes.result) {
        this.mData.dataDefault.listPosition = positionApiRes.result;
      }
    },

    async fn_getListDepartment() {
      const departmentApiRes = await DepartmentApi.list({
        fields: 'name',
        limit: 9999
      });
      if (departmentApiRes.result) {
        this.mData.dataDefault.listDepartment = departmentApiRes.result;
      }
    },

    async fn_getListOrganizationModelTreePromulgate() {
      const organizationApiRes = await OrganizationModelApi.list({
        limit: 9999,
      });
      if (organizationApiRes.result) {
        let result = organizationApiRes.result;
        let arrEmpIds = []
        result.forEach((item) => {
          if (item.employee_ids) arrEmpIds = arrEmpIds.concat(item.employee_ids)
        })
        arrEmpIds = _.uniq(arrEmpIds)
        await this.getListEmployeeInOrganizationModel(arrEmpIds)
        let treeList = [];
        // Get all parent
        let parents = result.filter((r) => r.parent_id == null);
        if (parents != null && parents.length > 0) {
          parents.forEach((organization1) => {
            let obj = {
              id: organization1.id,
              label: organization1.name
                ? organization1.name
                : "Tổ chức không xác định",
              children: [],
            };
            if (organization1.employee_ids && organization1.employee_ids.length > 0) {
              organization1.employee_ids.forEach((empId) => {
                const emp = this.mData.dataDefault.listEmployeeInOrganizationModel.find(
                  (e) => e.id == empId
                )
                if (emp) {
                  let pos = null;
                  if (emp.job_info) {
                    emp.job_info = MethodService.getValidJobInfo(emp.job_info, this.mData.dataDefault.listContractTypeId);
                    if (emp.job_info.length > 0) {
                      pos = this.mData.dataDefault.listPosition.find(
                        (position) => position.id == emp.job_info[0].position_id
                      );
                    }
                  }
                  let isTransfered = false;
                  if (this.$route.query.handle == "transfer" && this.mData.dataForm.transfer && this.mData.dataForm.transfer.person_ids) {
                    if (this.mData.dataForm.transfer.person_ids.includes(emp.id)) isTransfered = true;
                  }
                  obj.children.push({
                    // employee_id: emp.id,
                    id: emp.id,
                    type: 'employee',
                    order: 1,
                    label: emp.administrative_info.name.full_name,
                    field_filter: emp.administrative_info.name.full_name.toLowerCase(),
                    parents_field: this.buildParentField(organization1, result),
                    employee_no: emp ? emp.employee_no : "---",
                    position_name: pos ? pos.name : "",
                    phone_number: emp.administrative_info.phone_number,
                    email: emp.administrative_info.email,
                    avt: emp.image_id ? ExtensionService.urlImg + emp.image_id + "&r=square&w=512"
                      : emp.administrative_info.avatar_id
                      ? ExtensionService.urlImg + emp.administrative_info.avatar_id + "&r=square&w=512"
                      : "",
                    is_transfered: isTransfered,
                    children: [],
                  });
                }
              })
            }
            // Get child of parent
            const childs = result.filter((r) => r.parent_id == obj.id);
            if (childs != null && childs.length > 0) {
              childs.forEach((element) => {
                obj.children.push({
                  id: element.id,
                  label: element.name ? element.name : "Tổ chức không xác định",
                  order: element.order,
                  children: this.fn_getTreeByRecursionPromulgate(element, result),
                });
                if (element.employee_ids && element.employee_ids.length > 0) {
                  element.employee_ids.forEach((empId) => {
                    const emp = this.mData.dataDefault.listEmployeeInOrganizationModel.find(
                      (e) => e.id == empId
                    )
                    if (emp) {
                      let pos = null;
                      if (emp.job_info) {
                        emp.job_info = MethodService.getValidJobInfo(emp.job_info, this.mData.dataDefault.listContractTypeId);
                        if (emp.job_info.length > 0) {
                          pos = this.mData.dataDefault.listPosition.find(
                            (position) => position.id == emp.job_info[0].position_id
                          );
                        }
                      }

                      let isTransfered = false;
                      if (this.$route.query.handle == "transfer" && this.mData.dataForm.transfer && this.mData.dataForm.transfer.person_ids) {
                        if (this.mData.dataForm.transfer.person_ids.includes(emp.id)) isTransfered = true;
                      }

                      let updateChild = obj.children.find(e => e.id == element.id);
                      updateChild.children.push({
                        // employee_id: emp.id,
                        id: emp.id,
                        type: 'employee',
                        order: 1,
                        label: emp.administrative_info.name.full_name,
                        field_filter: emp.administrative_info.name.full_name.toLowerCase(),
                        parents_field: this.buildParentField(organization1, result),
                        employee_no: emp ? emp.employee_no : "---",
                        position_name: pos ? pos.name : "",
                        phone_number: emp.administrative_info.phone_number,
                        email: emp.administrative_info.email,
                        avt: emp.image_id ? ExtensionService.urlImg + emp.image_id + "&r=square&w=512"
                          : emp.administrative_info.avatar_id
                          ? ExtensionService.urlImg + emp.administrative_info.avatar_id + "&r=square&w=512"
                          : "",
                        is_transfered: isTransfered,
                        children: [],
                      })
                    }
                  })
                }
              });
              obj.children = obj.children.sort((a, b) => a.order - b.order);
            }
            treeList.push(obj);
          });
        }
        this.mData.dataDefault.listOrganizationModelTree = treeList;
      }
    },

    fn_getTreeByRecursionPromulgate(child, rootArr) {
      let childrenArr = rootArr.filter((r) => r.parent_id == child.id);
      if (!childrenArr || childrenArr.length == 0) return [];
      let root = childrenArr.map((organization1) => {
        let obj = {
          id: organization1.id,
          label: organization1.name ? organization1.name : "Không xác định",
          children: [],
          parents_field: this.buildParentField(organization1, rootArr),
        };
        obj.children = this.fn_getTreeByRecursionPromulgate(organization1, rootArr);
        if (organization1.employee_ids && organization1.employee_ids.length > 0) {
          organization1.employee_ids.forEach((empId) => {
            const emp = this.mData.dataDefault.listEmployeeInOrganizationModel.find((e) => e.id == empId)
            if (emp) {
              let pos = null;
              if (emp.job_info) {
                emp.job_info = MethodService.getValidJobInfo(emp.job_info, this.mData.dataDefault.listContractTypeId);
                if (emp.job_info.length > 0) {
                  pos = this.mData.dataDefault.listPosition.find(
                    (position) => position.id == emp.job_info[0].position_id
                  );
                }
              }

              let isTransfered = false;
              if (this.$route.query.handle == "transfer" && this.mData.dataForm.transfer && this.mData.dataForm.transfer.person_ids) {
                if (this.mData.dataForm.transfer.person_ids.includes(emp.id)) isTransfered = true;
              }
              obj.children.push({
                // employee_id: emp.id,
                id: emp.id,
                type: 'employee',
                order: 1,
                label: emp.administrative_info.name.full_name,
                field_filter: emp.administrative_info.name.full_name.toLowerCase(),
                parents_field: this.buildParentField(organization1, rootArr),
                employee_no: emp ? emp.employee_no : "---",
                position_name: pos ? pos.name : "",
                phone_number: emp.administrative_info.phone_number,
                email: emp.administrative_info.email,
                avt: emp.image_id ? ExtensionService.urlImg + emp.image_id + "&r=square&w=512"
                  : emp.administrative_info.avatar_id
                  ? ExtensionService.urlImg + emp.administrative_info.avatar_id + "&r=square&w=512"
                  : "",
                is_transfered: isTransfered,
                children: [],
              });
            }
          })
        }
        return obj;
      });
      return root;
    },

    async fn_getListDocumentGroupTreePromulgate(data) {
      if (data) {
        this.mData.dataDefault.listDocumentBusiness = data.map((group, i) => {
          let obj = {
            id: group.id,
            label: group.name,
            className: `${'level-' + i}`,
            children: [],
          }
          if (group.users && group.users.length > 0) {
            if (this.$route.query.handle !== "transfer" && this.$route.query.type != 'DOC_ISSUE' && this.tabName) {
              group.users = this.fn_removeMainSignerSigned(
                group.users,
                this.mData.dataForm.signers
              );
            }
            group.users.forEach(user => {
              let pos = null;
              if (user && user.job_info) {
                user.job_info = MethodService.getValidJobInfo(user.job_info, this.mData.dataDefault.listContractTypeId);
                if ( user.job_info.length > 0) {
                  pos = this.mData.dataDefault.listPosition.find(
                    (position) => position.id == user.job_info[0].position_id
                  );
                }
              }

              let isTransfered = false;
              if (this.$route.query.handle == "transfer" && this.mData.dataForm.transfer && this.mData.dataForm.transfer.person_ids) {
                if (this.mData.dataForm.transfer.person_ids.includes(user.id)) isTransfered = true;
              }
              const o = {
                id: user.id,
                label: user.administrative_info.name.full_name,
                field_filter: user.administrative_info.name.full_name.toLowerCase(),
                parents_field: group.name.toLowerCase(),
                employee_no: user ? user.employee_no : "---",
                position_name: pos ? pos.name : "",
                phone_number: user.administrative_info.phone_number,
                email: user.administrative_info.email,
                avt: user.image_id ? ExtensionService.urlImg + user.image_id + "&r=square&w=512"
                  : user.administrative_info.avatar_id
                  ? ExtensionService.urlImg + user.administrative_info.avatar_id + "&r=square&w=512"
                  : "",
                is_transfered: isTransfered,
                children: [],
              };
              obj.children.push(o);
            });
          }
          return obj;
        });
        return;
      }
      // CASE: Data = null
      let documentGroupApiRes = await DocumentGroupApi.list({ limit: 9999 });
      if (documentGroupApiRes.result) {
        documentGroupApiRes.result = await this.fn_changeDataDocumentGroupTree(documentGroupApiRes.result);
      }
      this.mData.dataDefault.listDocumentBusiness = documentGroupApiRes.result.map((group, i) => {
        let obj = {
          id: group.id,
          label: group.name,
          className: `${'level-' + i}`,
          children: [],
        }
        if (group.users && group.users.length > 0) {
          if (this.$route.query.handle !== "transfer" && this.$route.query.type != 'DOC_ISSUE' && this.tabName) {
            group.users = this.fn_removeMainSignerSigned(
              group.users,
              this.mData.dataForm.signers
            );
          }
          group.users.forEach(user => {
            let pos = null;
            if (user && user.job_info) {
              user.job_info = MethodService.getValidJobInfo(user.job_info, this.mData.dataDefault.listContractTypeId);
              if (user.job_info.length > 0) {
                pos = this.mData.dataDefault.listPosition.find(
                  (position) => position.id == user.job_info[0].position_id
                );
              }
            }

            let isTransfered = false;
            if (this.$route.query.handle == "transfer" && this.mData.dataForm.transfer && this.mData.dataForm.transfer.person_ids) {
              if (this.mData.dataForm.transfer.person_ids.includes(user.id)) isTransfered = true;
            }
            const o = {
              id: user.id,
              type: 'employee',
              label: user.administrative_info.name.full_name,
              field_filter: user.administrative_info.name.full_name.toLowerCase(),
              parents_field: group.name.toLowerCase(),
              employee_no: user ? user.employee_no : "---",
              position_name: pos ? pos.name : "",
              phone_number: user.administrative_info.phone_number,
              email: user.administrative_info.email,
              avt: user.image_id ? ExtensionService.urlImg + user.image_id + "&r=square&w=512"
                : user.administrative_info.avatar_id
                ? ExtensionService.urlImg + user.administrative_info.avatar_id + "&r=square&w=512"
                : "",
              is_transfered: isTransfered,
              children: [],
            };
            obj.children.push(o);
          });
        }
        return obj;
      });
    },

    async fn_getListDocumentGroupTree(data) {
      if (data) {
        this.mData.dataDefault.listDocumentBusiness = data.map((group, i) => {
          let obj = {
            id: group.id,
            label: group.name,
            className: `${'level-' + i}`,
            children: [],
          }
          if (group.users && group.users.length > 0) {
            if (this.$route.query.handle !== "transfer" && this.$route.query.type != 'DOC_ISSUE' && this.tabName) {
              group.users = this.fn_removeMainSignerSigned(
                group.users,
                this.mData.dataForm.signers
              );
            }
            group.users.forEach(user => {
              let isTransfered = false;
              if (this.$route.query.handle == "transfer" && this.mData.dataForm.transfer && this.mData.dataForm.transfer.person_ids) {
                if (this.mData.dataForm.transfer.person_ids.includes(user.id)) isTransfered = true;
              }

              const o = {
                id: user.id,
                label: user.administrative_info.name.full_name,
                field_filter: user.administrative_info.name.full_name.toLowerCase(),
                parents_field: group.name.toLowerCase(),
                employee_no: user ? user.employee_no : "---",
                position_name: "",
                phone_number: user.administrative_info.phone_number,
                email: user.administrative_info.email,
                avt: user.image_id ? ExtensionService.urlImg + user.image_id + "&r=square&w=512"
                  : user.administrative_info.avatar_id
                  ? ExtensionService.urlImg + user.administrative_info.avatar_id + "&r=square&w=512"
                  : "",
                is_transfered: isTransfered,
                children: [],
              };

              if (user.job_info && user.job_info.length > 0) {
                user.job_info = MethodService.getValidJobInfo(user.job_info, this.mData.dataDefault.listContractTypeId);
                user.job_info.forEach((job) => {
                  let e1 = {...o};
                  const pos = this.mData.dataDefault.listPosition.find(
                    (position) => position.id == job.position_id
                  );
                  e1.position_id = job.position_id;
                  e1.position_name = pos ? pos.name : "";
                  if (e1.position_id)
                    obj.children.push(e1);
                });
              } else {
                // obj.children.push(o);
              }
            });
          }
          return obj;
        });
        return;
      }
      // CASE: Data = null
      let documentGroupApiRes = await DocumentGroupApi.list({ limit: 9999 });
      if (documentGroupApiRes.result) {
        documentGroupApiRes.result = await this.fn_changeDataDocumentGroupTree(documentGroupApiRes.result);
      }
      this.mData.dataDefault.listDocumentBusiness = documentGroupApiRes.result.map((group, i) => {
        let obj = {
          id: group.id,
          label: group.name,
          className: `${'level-' + i}`,
          children: [],
        }
        if (group.users && group.users.length > 0) {
          if (this.$route.query.handle !== "transfer" && this.$route.query.type != 'DOC_ISSUE' && this.tabName) {
            group.users = this.fn_removeMainSignerSigned(
              group.users,
              this.mData.dataForm.signers
            );
          }
          group.users.forEach(user => {
            let isTransfered = false;
            if (this.$route.query.handle == "transfer" && this.mData.dataForm.transfer && this.mData.dataForm.transfer.person_ids) {
              if (this.mData.dataForm.transfer.person_ids.includes(user.id)) isTransfered = true;
            }
            const o = {
              id: user.id,
              type: 'employee',
              label: user.administrative_info.name.full_name,
              field_filter: user.administrative_info.name.full_name.toLowerCase(),
              parents_field: group.name.toLowerCase(),
              employee_no: user ? user.employee_no : "---",
              phone_number: user.administrative_info.phone_number,
              email: user.administrative_info.email,
              avt: user.image_id ? ExtensionService.urlImg + user.image_id + "&r=square&w=512"
                : user.administrative_info.avatar_id
                ? ExtensionService.urlImg + user.administrative_info.avatar_id + "&r=square&w=512"
                : "",
              is_transfered: isTransfered,
              children: [],
            };

            if (user.job_info && user.job_info.length > 0) {
              user.job_info = MethodService.getValidJobInfo(user.job_info, this.mData.dataDefault.listContractTypeId);
              user.job_info.forEach((job) => {
                let e1 = {...o};
                const pos = this.mData.dataDefault.listPosition.find(
                  (position) => position.id == job.position_id
                );
                e1.position_id = job.position_id;
                e1.position_name = pos ? pos.name : "";
                if (e1.position_id)
                  obj.children.push(e1);
              });
            } else {
              // obj.children.push(o);
            }
          });
        }
        return obj;
      });
    },

    fn_changeDataDocumentGroupTree(data) {
      data.forEach(group => {
        if (group.user_ids && group.user_ids.length > 0) {
          let listUsers = [];
          group.user_ids.forEach(userId => {
            const e = this.mData.dataDefault.listEmployee.find(emp => emp.id == userId);
            if (e) listUsers.push(e);
          });
          group.users = listUsers;
        }
      });
      return data;
    },

    async fn_getListBranch() {
      const branchApiRes = await BranchApi.list({ limit: 9999 });
      if (branchApiRes.result) {
        this.mData.dataDefault.listBranch = branchApiRes.result;
      }
    },

    async fn_getListDocumentBusiness() {
      const documentBusinessApiRes = await DocumentBusinessApi.list({ limit: 9999 });
      if (documentBusinessApiRes.result) {
        this.mData.dataDefault.listDocumentBusiness = documentBusinessApiRes.result;
      }
    },

    async fn_getListDocumentTemplateCategories() {
      const res = await ContractTemplateCategoryApi.list({ limit: 1000 });
      if (res.result) {
        this.mData.dataDefault.listDocumentTemplateCategories = res.result;
      }
    },

    async fn_getListDocumentRespectively(type) {
      const documentCategoryApiRes = await DocumentCategoryApi.list({
        filters: `type=${type}`,
        limit: 99999,
        sort: "order",
      });
      if (type == "DOC_TYPE" && documentCategoryApiRes.result) {
        this.mData.dataDefault.listDocumentType = documentCategoryApiRes.result;

        setTimeout(() => {
          if (this.mData.dataDefault.listDocumentType.length > 0) {
            if (
              (this.$route.query.fromDetail && this.$route.query.recreate) ||
              (this.$route.query.fromDetail && this.$route.query.edit)
            ) {
              return;
            }
            const defaultType = this.mData.dataDefault.listDocumentType.find(docType => docType.code === 'CV');
            this.mData.dataForm.document_category_id = defaultType ? defaultType.id : '';
          }
        }, 1000);
      }
    },

    async fn_getListDocumentBook() {
      const documentTextBookApiRes = await BookApi.list({
        limit: 99999,
        sort: "order",
      });
      if (documentTextBookApiRes.result) {
        this.mData.dataDefault.listDocumentBook = documentTextBookApiRes.result;
      }
    },

    async uploadFile(file, fileList) {
      this.isPdf = false;
      let lastIndexOfDot = file.name.lastIndexOf(".");
      let fileType = file.name.substr(lastIndexOfDot + 1, file.name.length);
      if (file && file.name) {
        let type = [
          "pdf",
          "docx",
          "doc",
          "xlsx",
          "xls",
        ];
        if (!type.includes(fileType.toLowerCase())) {
          this.$notify.info({
            message: "File không đúng định dạng.",
            duration: 3000,
            customClass: "doc-info",
          });
          fileList.pop();
          return;
        }
      }
      const isLt25M = file.size / 1024 / 1024 <= 20;
      const isLt5M = file.size / 1024 / 1024 <= 5;

      if (!isLt25M && fileType == 'pdf') {
        this.$notify.info({
          message: "Dung lượng file PDF tải lên tối đa là 20MB.",
          duration: 3000,
          customClass: "doc-info",
        });
        fileList.pop();
        return;
      } else if (!isLt5M && (fileType == 'doc' || fileType == 'docx' || fileType == 'xlsx' || fileType == 'xls')) {
        this.$notify.info({
          message: "Dung lượng file DOC/DOCX/XLSX/XLS tải lên tối đa là 5MB.",
          duration: 3000,
          customClass: "doc-info",
        });
        fileList.pop();
        return;
      }

      // Tạo blob URL để FilePreview render ngay (không cần đợi upload xong)
      if (file.raw) {
        if (this._previewBlobUrl) URL.revokeObjectURL(this._previewBlobUrl);
        this._previewBlobUrl = URL.createObjectURL(file.raw);
        this.url = this._previewBlobUrl;
        this.fileExtension = fileType.toLowerCase();
        this.isPdf = fileType.toLowerCase() === 'pdf';
      }

      ExtensionService.upload(file, "File_Van_Ban_Dien_Tu")
        .then((res) => {
          const uploadedFileId = res.result;
          this.mData.dataForm.doc_file.doc_id = res.result;
          this.mData.dataForm.doc_file.doc_name = file.name.slice(0, file.name.lastIndexOf("."));
          this.mData.dataForm.doc_file.capacity = file.size / 1024 / 1024;
          this.mData.dataForm.doc_file.type = fileType;
          fileList.forEach((el) => {
            if (el.uid == file.uid) {
              el.id = uploadedFileId;
              el.url = ExtensionService.urlDowloadFile + uploadedFileId;
            }
          });
          this.mData.fileUploadOption.fileMain.fileList = fileList;

          const uploadedFile = fileList.find((el) => el.uid == file.uid);
          if (typeof this.applyPreviewFile === "function") {
            this.applyPreviewFile(uploadedFile);
          } else if (fileType.toLowerCase() == 'pdf') {
            this.isPdf = true;
            this.url = ExtensionService.getDocumentPreviewUrl(uploadedFileId);
          } else {
            this.url = ExtensionService.urlDowloadFile + uploadedFileId;
          }
        })
        .catch((err) => {
          this.$notify.warning({
            message: "Có lỗi xảy ra khi tải file lên.",
            duration: 3000,
            customClass: "doc-warning",
          });
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },

    previewFile(file) {
      window.open(ExtensionService.urlDowloadFile + file.id);
    },

    removeFile(file, fileList) {
      if (typeof this.applyPreviewFile === "function") {
        this.applyPreviewFile(null);
      } else {
        this.url = null;
      }
      this.mData.fileUploadOption.fileMain.fileList = [];
      this.mData.dataForm.doc_file.doc_id = null;
    },

    // File đính kèm
    async uploadOtherFiles(file, fileList) {
      let lastIndexOfDot = file.name.lastIndexOf(".");
      let fileType = file.name.substr(lastIndexOfDot + 1, file.name.length);
      let type = [
        "pdf",
        "docx",
        "doc",
        "xlsx",
        "xls",
      ];
      if (file && file.name) {
        if (!type.includes(fileType.toLowerCase())) {
          this.$notify.info({
            message: "File không đúng định dạng.",
            duration: 3000,
            customClass: "doc-info",
          });
          fileList.pop();
          return;
        }
      }
      const isLt25M = file.size / 1024 / 1024 < 20;
      if (!isLt25M) {
        this.$notify.info({
          message: "Dung lượng file tải lên tối đa là 20MB.",
          duration: 3000,
          customClass: "doc-info",
        });
        fileList.pop();
        return;
      }

      ExtensionService.upload(file, "File_Dinh_Kem_Van_Ban_Dien_Tu")
        .then((res) => {
          const o = {
            other_id: res.result,
            other_name: file.name.slice(0, file.name.lastIndexOf(".")),
            capacity: file.size / 1024 / 1024,
            type: fileType,
          };
          this.mData.dataForm.other_files.push(o);
          fileList.forEach((el) => {
            if (el.uid == file.uid) {
              el.id = res.result;
            }
          });
          this.mData.fileUploadOption.fileOther.fileList = fileList;
        })
        .catch(() => {
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },

    previewOtherFiles(file) {
      window.open(ExtensionService.urlDowloadFile + file.id);
    },

    removeOtherFiles(file, fileList) {
      let data = fileList.map((el) => el.id);
      this.mData.dataForm.other_files = data;
    },

    async fn_changeData(resData) {
      if (resData.job_info[0].position_id) {
        const positionApiRes = await PositionApi.findById(
          resData.job_info[0].position_id
        );
        if (positionApiRes.result) {
          resData.job_info[0].position_name = positionApiRes.result.name;
        }
      }
      if (resData.job_info[0].department_id) {
        const departmentApiRes = await DepartmentApi.findById(
          resData.job_info[0].department_id
        );
        if (departmentApiRes.result) {
          resData.job_info[0].department_name = departmentApiRes.result.name;
        }
      }
      return resData;
    },

    async fn_viewDepartmentEmployee(rowId) {
      if (!rowId) return;
      this.dataDepartmentEmployee = [];
      this.dialogDepartmentEmployee = true;
      await this.fn_getListDepartment();
      await this.fn_getListPosition();
      await this.fn_getListEmployeeByDepartmentId(rowId);
    },

    async fn_getListEmployeeByDepartmentId(id) {
      const employeeApiRes = await EmployeeApi.list({
        filters: `disabled=false&status=DANG_LAM_VIEC&job_info.department_id=${id}`,
        fields: "administrative_info,job_info",
        limit: 3000,
      });
      if (employeeApiRes.result && employeeApiRes.result.length > 0) {
        this.dataDepartmentEmployee = this.fn_changeDataDepartmentEmployee(employeeApiRes.result);
      }
    },

    fn_changeDataDepartmentEmployee(data) {
      data.forEach(emp => {
        if (emp.job_info[0].department_id) {
          const o = this.mData.dataDefault.listDepartment.find(department => department.id == emp.job_info[0].department_id);
          emp.job_info[0].department_name = o ? o.name : '';
        }
        if (emp.job_info[0].position_id) {
          const o = this.mData.dataDefault.listPosition.find(position => position.id == emp.job_info[0].position_id);
          emp.job_info[0].position_name = o ? o.name : '';
        }
      });
      return data;
    },

    fn_formatDatetime(val) {
      return MethodService.formatDate(val, 'datetime');
    },

    fn_formatDatetimeToMilliseconds(val) {
      return MethodService.formatDateToMilliseconds(val);
    },

    fn_formatDate(val) {
      return MethodService.formatDate(val, 'date');
    },

    async fn_goToDetail(idDoc, type) {
      const documentApiRes = await DocumentApi.ReadDocument(idDoc);
      this.fn_checkFilterDoc(type);
      if (documentApiRes.result) {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: idDoc },
          query: this.fn_checkFilterDoc(type)
        }).catch(err => { });
      }
    },

    fn_checkFilterDoc(type) {
      let query = { type: type };
      if (this.dataSearch.type && !this.dataSearch.status) {
        query.filterType = this.dataSearch.type
      } else if (!this.dataSearch.type && this.dataSearch.status) {
        query.statusFilter = this.dataSearch.status
      } else if (this.dataSearch.type && this.dataSearch.status){
        query.filterType = this.dataSearch.type
        query.statusFilter = this.dataSearch.status
      }
      return query;
    },

    fn_goToCreate() {
      this.$router.push({
        name: "Admin-ElectronicDocument-create",
        query: {
          type: 'DOC_SIGN',
        }
      }).catch(err => { });
    },

    checkStatusRejectForSign(data) {
      this.isHideButton = false;
      if (
        data.author_id != this.mData.currentUser.id
      ) {
        if (
          data.status &&
          data.status == 'REJECT_FOR_SIGN'
        ) {
          this.$notify.info({
            message: "Văn bản đã bị hủy trình ký, bạn không có quyền xem văn bản này.",
            duration: 3000,
            customClass: "doc-info",
          });
          return true;
        }
        const mainSigner = (data.signers || []).find(signer => signer.user_id == this.mData.currentUser.id);
        if (
          data.status &&
          data.status == 'RECALLED' &&
          ((!mainSigner &&
            (!this.listRole || this.listRole.length == 0 || this.listRole.length > 0 &&
               !this.listRole.includes("VT"))) ||
          (!mainSigner && this.docType == 'DOC_IN' && data.publish && data.publish.publisher_to_ids &&
            data.publish.publisher_to_ids.includes(this.mData.currentUser.id) &&
              this.listRole && this.listRole.includes("VT")))
        ) {
          this.isHideButton = true;
          if (
            this.$route.query.statusFilter !== "DOC_DRAFF_REJECTED" &&
            data.status != "RECALLED"
          ) {
            this.$notify.info({
              message: "Văn bản đã bị thu hồi, bạn không có quyền xem văn bản này.",
              duration: 3000,
              customClass: "doc-info",
            });
          }
          return true;
        }
        if (
          data.status &&
          data.status == 'RECALLED' && mainSigner
        ) {
          this.isHideButton = true;
          return;
        }
        if (this.docType == 'DOC_SIGN_CONSENT' && !mainSigner) {
          this.$notify.info({
            message: "Bạn không có quyền thao tác trên văn bản này.",
            duration: 3000,
            customClass: "doc-info",
          });
          return true;
        }
        const mainWaitingSigner = (data.signers || []).find(signer => signer.status == 'WAITING');
        if (
          (this.docType == 'DOC_SIGN_TEMP' && !mainWaitingSigner) ||
          (this.docType == 'DOC_SIGN_TEMP' && mainWaitingSigner && !mainWaitingSigner.request_temp_signers) ||
          (this.docType == 'DOC_SIGN_TEMP' &&
            mainWaitingSigner && mainWaitingSigner.request_temp_signers &&
            mainWaitingSigner.request_temp_signers.findIndex(tempSigner => tempSigner.user_id == this.mData.currentUser.id) < 0)
        ) {
          this.$notify.info({
            message: "Bạn không có quyền thao tác trên văn bản này.",
            duration: 3000,
            customClass: "doc-info",
          });
          return true;
        }
      } else if (data.author_id == this.mData.currentUser.id) {
        const mainSigner = (data.signers || []).find(signer => signer.user_id == this.mData.currentUser.id);
        if (
          data.status &&
          data.status == 'RECALLED' &&
          ((!mainSigner &&
            (!this.listRole || this.listRole.length == 0 || this.listRole.length > 0 &&
              !this.listRole.includes("VT"))) ||
          (!mainSigner && this.docType == 'DOC_IN' && data.publish && data.publish.publisher_to_ids &&
            data.publish.publisher_to_ids.includes(this.mData.currentUser.id) &&
            this.listRole && this.listRole.includes("VT")))
        ) {
          if (
            this.$route.query.statusFilter !== "DOC_DRAFF_REJECTED" &&
            data.status != "RECALLED"
          ) {
            this.$notify.info({
              message: "Văn bản đã bị thu hồi, bạn không có quyền xem văn bản này.",
              duration: 3000,
              customClass: "doc-info",
            });
          }
          this.isHideButton = true;
          return true;
        }
        if (
          data.status &&
          data.status == 'RECALLED' && mainSigner
        ) {
          this.isHideButton = true;
          return false;
        }
        const mainWaitingSigner = (data.signers || []).find(signer => signer.status == 'WAITING');
        if (
          (this.docType == 'DOC_SIGN_CONSENT' && !mainSigner) ||
          (this.docType == 'DOC_SIGN_CONSENT' && mainSigner && data.status === 'REJECT_FOR_SIGN') ||
          (this.docType == 'DOC_SIGN_TEMP' && !mainWaitingSigner) ||
          (this.docType == 'DOC_SIGN_TEMP' && mainWaitingSigner && !mainWaitingSigner.request_temp_signers) ||
          (this.docType == 'DOC_SIGN_TEMP' &&
            mainWaitingSigner && mainWaitingSigner.request_temp_signers &&
            mainWaitingSigner.request_temp_signers.findIndex(tempSigner => tempSigner.user_id == this.mData.currentUser.id) < 0)
        ) {
          this.$notify.info({
            message: "Bạn không có quyền thao tác trên văn bản này.",
            duration: 3000,
            customClass: "doc-info",
          });
          return true;
        }
      }
    },

    async fn_goToCreateFromDetail() {
      const documentInApiRes = await DocumentApi.findById(this.$router.currentRoute.params.id)
      if (!this.checkStatusRejectForSign(documentInApiRes.result) && this.isHideButton) {
        this.$notify.info({
          message: "Bạn không có quyền thao tác trên văn bản này.",
          duration: 3000,
          customClass: "doc-info",
        });
        return;
      } else if (this.checkStatusRejectForSign(documentInApiRes.result)) {
        this.fn_goToList();
        return;
      }
      this.$router.push({
        name: "Admin-ElectronicDocument-create",
        query: {
          type: this.$route.query.type,
          fromDetail: this.mData.fileUploadOption.fileMain.fileList[0].id,
          doc_name: this.mData.dataForm.doc_file.doc_name,
          doc_type: this.mData.dataForm.doc_file.type,
          capacity: this.mData.dataForm.doc_file.capacity,
        }
      }).catch(err => { });
    },

    fn_goToList() {
      const tab = this.$route.query.type == "FILTER"
        ? 'TatCa'
        : this.$route.query.type == "DOC_IN"
          ? 'VanBanDen'
          : this.$route.query.type == "DOC_OUT"
            ? 'VanBanDi'
            : this.$route.query.type == "DOC_SIGN"
              ? 'TrinhKy'
              : this.$route.query.type == "DOC_SIGN_CONSENT"
                ? 'KyDuyet'
                : this.$route.query.type == "DOC_SIGN_TEMP"
                  ? 'KyNhay'
                  : this.$route.query.type == "DOC_ISSUE" ? 'ChoBanHanh'
                    : 'CayThuMuc';
      this.$router.push({
        name: 'Admin-DocumentsGeneral',
        query: {
          tab: tab,
        }
      }).catch(() => { });
    },

    fn_goToTransfer(docId, docName) {
      this.$router.push({
        name: "Admin-ElectronicDocument-transfer",
        params: { id: docId },
        query: {
          name: docName,
          handle: 'transfer'
        },
      }).catch(err => { });
    },

    fn_goToTempSign(docId, docName) {
      this.$router.push({
        name: "Admin-ElectronicDocument-transfer",
        params: { id: docId },
        query: {
          type: 'DOC_SIGN_CONSENT',
          name: docName,
          handle: "request-sign-temp",
        },
      }).catch(err => { });
    },

    fn_goBack() {
      this.$router.go(-1);
    },

    forceUpdateUI() {
      this.$forceUpdate();
    },

    buildParentField(organization, result){
      if (!organization.parent_id) {
        return organization.name ? organization.name.toLowerCase() : "";
      } else {
        return (organization.name ? organization.name.toLowerCase() : "")
          + " " + this.buildParentField(result.find(r => r.id == organization.parent_id), result);
      }
    },

    async fn_getListOrganizationModelTree() {
      const organizationApiRes = await OrganizationModelApi.list({
        limit: 9999,
      });
      if (organizationApiRes.result) {
        let result = organizationApiRes.result;
        let arrEmpIds = []
        result.forEach((item) => {
          if (item.employee_ids) arrEmpIds = arrEmpIds.concat(item.employee_ids)
        })
        arrEmpIds = _.uniq(arrEmpIds)
        await this.getListEmployeeInOrganizationModel(arrEmpIds)
        let treeList = [];
        // Get all parent
        let parents = result.filter((r) => r.parent_id == null);
        if (parents != null && parents.length > 0) {
          parents.forEach((organization1) => {
            let obj = {
              id: organization1.id,
              label: organization1.name
                ? organization1.name
                : "Tổ chức không xác định",
              children: [],
            };
            if (organization1.employee_ids && organization1.employee_ids.length > 0) {
              organization1.employee_ids.forEach((empId) => {
                const emp = this.mData.dataDefault.listEmployeeInOrganizationModel.find(
                  (e) => e.id == empId
                )
                if (emp) {
                  let isTransfered = false;
                  if (this.$route.query.handle == "transfer" && this.mData.dataForm.transfer && this.mData.dataForm.transfer.person_ids) {
                    if (this.mData.dataForm.transfer.person_ids.includes(emp.id)) isTransfered = true;
                  }

                  let objPush = {
                    id: emp.id,
                    type: 'employee',
                    order: 1,
                    label: emp.administrative_info.name.full_name,
                    field_filter: emp.administrative_info.name.full_name.toLowerCase(),
                    parents_field: this.buildParentField(organization1, result),
                    employee_no: emp.employee_no ? emp.employee_no : "---",
                    phone_number: emp.administrative_info.phone_number,
                    email: emp.administrative_info.email,
                    avt: emp.image_id ? ExtensionService.urlImg + emp.image_id + "&r=square&w=512" :
                        emp.administrative_info.avatar_id ? ExtensionService.urlImg + emp.administrative_info.avatar_id + "&r=square&w=512"
                        : "",
                    is_transfered: isTransfered,
                    children: [],
                  };

                  if (emp.job_info && emp.job_info.length > 0) {
                    emp.job_info = MethodService.getValidJobInfo(emp.job_info, this.mData.dataDefault.listContractTypeId);
                    emp.job_info.forEach((job) => {
                      let e1 = {...objPush};
                      const pos = this.mData.dataDefault.listPosition.find(
                        (position) => position.id == job.position_id
                      );
                      e1.position_id = job.position_id;
                      e1.position_name = pos ? pos.name : "";
                      if (e1.position_id)
                        obj.children.push(e1);
                    });
                  } else {
                    // obj.children.push(objPush);
                  }
                }
              })
            }
            // Get child of parent
            const childs = result.filter((r) => r.parent_id == obj.id);
            if (childs != null && childs.length > 0) {
              childs.forEach((element) => {
                obj.children.push({
                  id: element.id,
                  label: element.name ? element.name : "Tổ chức không xác định",
                  parents_field: this.buildParentField(organization1, result),
                  order: element.order,
                  children: this.fn_getTreeByRecursion(element, result),
                });
                if (element.employee_ids && element.employee_ids.length > 0) {
                  element.employee_ids.forEach((empId) => {
                    const emp = this.mData.dataDefault.listEmployeeInOrganizationModel.find(
                      (e) => e.id == empId
                    )
                    if (emp) {
                      let isTransfered = false;
                      if (this.$route.query.handle == "transfer" && this.mData.dataForm.transfer && this.mData.dataForm.transfer.person_ids) {
                        if (this.mData.dataForm.transfer.person_ids.includes(emp.id)) isTransfered = true;
                      }

                      let objPush = {
                        id: emp.id,
                        type: 'employee',
                        order: 1,
                        label: emp.administrative_info.name.full_name,
                        field_filter: emp.administrative_info.name.full_name.toLowerCase(),
                        parents_field: this.buildParentField(element, result),
                        employee_no: emp ? emp.employee_no : "---",
                        phone_number: emp.administrative_info.phone_number,
                        email: emp.administrative_info.email,
                        avt: emp.image_id ? ExtensionService.urlImg + emp.image_id + "&r=square&w=512" :
                            emp.administrative_info.avatar_id ? ExtensionService.urlImg + emp.administrative_info.avatar_id + "&r=square&w=512"
                            : "",
                        is_transfered: isTransfered,
                        children: [],
                      };

                      let updateChild = obj.children.find(e => e.id == element.id);

                      if (emp.job_info && emp.job_info.length > 0) {
                        emp.job_info = MethodService.getValidJobInfo(emp.job_info, this.mData.dataDefault.listContractTypeId);
                        emp.job_info.forEach((job) => {
                          let e1 = {...objPush};
                          const pos = this.mData.dataDefault.listPosition.find(
                            (position) => position.id == job.position_id
                          );
                          e1.position_id = job.position_id;
                          e1.position_name = pos ? pos.name : "";
                          if (e1.position_id)
                            updateChild.children.push(e1);
                        });
                      } else {
                        // updateChild.children.push(objPush);
                      }
                    }
                  })
                }
              });
              obj.children = obj.children.sort((a, b) => a.order - b.order);
            }
            treeList.push(obj);
          });
        }
        this.mData.dataDefault.listOrganizationModelTree = treeList;
      }
    },

    async getListEmployeeInOrganizationModel(arrIds) {
      const employeeApiRes = await EmployeeApi.list({
        fields: 'id,administrative_info,employee_no,job_info,image_id',
        limit: arrIds.length,
        filters: `id:in:${arrIds.join(',')}`,
      })
      if (this.$route.query.handle !== "transfer" && this.$route.query.type != 'DOC_ISSUE' && this.tabName) {
        this.mData.dataDefault.listEmployeeInOrganizationModel = this.fn_removeMainSignerSigned(
          employeeApiRes.result,
          this.mData.dataForm.signers
        );
        return;
      }
      this.mData.dataDefault.listEmployeeInOrganizationModel = employeeApiRes.result
    },

    fn_getTreeByRecursion(child, rootArr) {
      let childrenArr = rootArr.filter((r) => r.parent_id == child.id);
      if (!childrenArr || childrenArr.length == 0) return [];
      let root = childrenArr.map((organization1) => {
        let obj = {
          id: organization1.id,
          label: organization1.name ? organization1.name : "Không xác định",
          children: [],
          parents_field: this.buildParentField(organization1, rootArr),
        };
        obj.children = this.fn_getTreeByRecursion(organization1, rootArr);
        if (organization1.employee_ids && organization1.employee_ids.length > 0) {
          organization1.employee_ids.forEach((empId) => {
            const emp = this.mData.dataDefault.listEmployeeInOrganizationModel.find((e) => e.id == empId)
            if (emp) {
              let isTransfered = false;
              if (this.$route.query.handle == "transfer" && this.mData.dataForm.transfer && this.mData.dataForm.transfer.person_ids) {
                if (this.mData.dataForm.transfer.person_ids.includes(emp.id)) isTransfered = true;
              }

              let objPush = {
                id: emp.id,
                type: 'employee',
                order: 1,
                label: emp.administrative_info.name.full_name,
                field_filter: emp.administrative_info.name.full_name.toLowerCase(),
                parents_field: this.buildParentField(organization1, rootArr),
                employee_no: emp ? emp.employee_no : "---",
                phone_number: emp.administrative_info.phone_number,
                email: emp.administrative_info.email,
                avt: emp.image_id ? ExtensionService.urlImg + emp.image_id + "&r=square&w=512" :
                    emp.administrative_info.avatar_id ? ExtensionService.urlImg + emp.administrative_info.avatar_id + "&r=square&w=512"
                    : "",
                is_transfered: isTransfered,
                children: [],
              };

              if (emp.job_info && emp.job_info.length > 0) {
                emp.job_info = MethodService.getValidJobInfo(emp.job_info, this.mData.dataDefault.listContractTypeId);
                emp.job_info.forEach((job) => {
                  let e1 = {...objPush};
                  const pos = this.mData.dataDefault.listPosition.find(
                    (position) => position.id == job.position_id
                  );
                  e1.position_id = job.position_id;
                  e1.position_name = pos ? pos.name : "";
                  if (e1.position_id)
                    obj.children.push(e1);
                });
              } else {
                // obj.children.push(objPush);
              }
            }
          })
        }
        return obj;
      });
      return root;
    },

    async fn_getCompanySign() {
      const companySignApiRes = await CompanySignApi.list();
      if (companySignApiRes.result) {
        let objSign = {};
        if (
          companySignApiRes.result &&
          companySignApiRes.result.length > 0
        ) {
          if (!companySignApiRes.result[0].image_ids) {
            companySignApiRes.result[0].image_ids = [];
          }
          objSign = companySignApiRes.result[0];
        } else {
          objSign = {
            employee_id: this.mData.currentCompany.id,
            image_ids: [],
          };
        }

        (objSign.image_ids || []).forEach((item) => {
          this.mData.dataDefault.listCompanySign.push({
            sign_image_id: item,
            url: ExtensionService.urlImg + item,
          });
        });
      }
    },

    async fn_getSignRequestHistory() {
      const signRequestHistoryApiRes = await SignRequestHistoryApi.list({
        filters: `signator_id=$$user_id`,
        limit: 10,
        sort: '-sign_at'
      });
      if (signRequestHistoryApiRes.result) {
        this.listSignRequestHistory = await this.fn_changeDataSignHistory(signRequestHistoryApiRes.result);
        this.listNearestHistory = this.listSignRequestHistory.filter(person => person.administrative_info);
      }
    },

    async fn_getTempSignRequestHistory() {
      const tempSignRequestHistoryApiRes = await TempSignRequestHistoryApi.list({
        filters: `signator_id=$$user_id`,
        limit: 10,
        sort: '-sign_at'
      });
      if (tempSignRequestHistoryApiRes.result) {
        this.listTempSignRequestHistory = await this.fn_changeDataHistoryTempSign(tempSignRequestHistoryApiRes.result);
        this.listTempSignRequestHistory = this.listTempSignRequestHistory.filter(person => person.administrative_info);
      }
    },

    async fn_getTransferHistory() {
      const transferHistoryApiRes = await TransferHistoryApi.list({
        filters: `transfer_id=$$user_id`,
        limit: 10,
        sort: '-transfer_at'
      });
      if (transferHistoryApiRes.result) {
        this.listTransferHistory = await this.fn_changeDataHistoryTempSign(transferHistoryApiRes.result);
        this.listTransferHistory = this.listTransferHistory.filter(person => person.administrative_info)
      }
    },

    async fn_getPublishHistory() {
      const publishHistoryApiRes = await PublishHistoryApi.list({
        filters: `publisher_id=$$user_id`,
        limit: 10,
        sort: '-publish_at'
      });
      if (publishHistoryApiRes.result) {
        this.listPublishHistory = await this.fn_changeDataHistory(publishHistoryApiRes.result);
        this.listNearestHistory = this.listPublishHistory.filter(person => person.administrative_info);
      }
    },

    fn_changeDataSignHistory(data) {
      let listResult = [];
      data.forEach(person => {
        const emp = this.mData.dataDefault.listEmployee.find(
          (emp) => emp.id == person.signer_id
        );
        person.administrative_info = emp ? emp.administrative_info : null;
        person.name_filter = emp ? emp.administrative_info.name.full_name.toLowerCase() : null;
        person.employee_no = emp ? emp.employee_no : "---";
        person.job_info = emp && emp.job_info ? emp.job_info : [];
        person.avt = emp && emp.image_id ? ExtensionService.urlImg + emp.image_id + "&r=square&w=512"
          : emp && emp.administrative_info && emp.administrative_info.avatar_id
          ? ExtensionService.urlImg + emp.administrative_info.avatar_id + "&r=square&w=512"
          : "";
        person.value = person.value ? person.value : false;

        if (person.job_info && person.job_info.length > 0) {
          person.job_info = MethodService.getValidJobInfo(person.job_info, this.mData.dataDefault.listContractTypeId);
          person.job_info.forEach((job) => {
            let e1 = {...person};
            const pos = this.mData.dataDefault.listPosition.find(
            (position) => position.id == job.position_id
            );
            e1.position_id = job.position_id;
            e1.position_name = pos ? pos.name : "";
            if (e1.position_id)
              listResult.push(e1);
          });
        } else {
          listResult.push(person);
        }
      });
      return listResult;
    },

    fn_changeDataHistoryTempSign(data) {
      let listResult = [];
      data.forEach((e) => {
        const emp = this.mData.dataDefault.listEmployee.find(employee => employee.id == e.signer_id || employee.id == e.receiver_id);
        if (emp) {
          e.administrative_info = emp ? emp.administrative_info : null;
          e.job_info = emp.job_info ? emp.job_info : [];
          e.name_filter = emp.administrative_info ? emp.administrative_info.name.full_name.toLowerCase(): null;
          e.avt = emp.image_id ? ExtensionService.urlImg + emp.image_id + "&r=square&w=512"
            : emp.administrative_info && emp.administrative_info.avatar_id
            ? ExtensionService.urlImg + emp.administrative_info.avatar_id + "&r=square&w=512"
            : "";
          e.employee_no = emp ? emp.employee_no : "---";
          e.value = false;

          if (e.job_info && e.job_info.length > 0) {
            e.job_info = MethodService.getValidJobInfo(e.job_info, this.mData.dataDefault.listContractTypeId);
            e.job_info.forEach((job) => {
              let e1 = {...e};
              const pos = this.mData.dataDefault.listPosition.find(
              (position) => position.id == job.position_id
              );
              e1.position_id = job.position_id;
              e1.position_name = pos ? pos.name : "";
              if (e1.position_id)
                listResult.push(e1);
            });
          } else {
            listResult.push(e);
          }
        }
      });
      return listResult;
    },

    fn_changeDataHistory(data) {
      data.forEach((e) => {
        const emp = this.mData.dataDefault.listEmployee.find(employee => employee.id == e.signer_id || employee.id == e.receiver_id);
        if (emp) {
          e.administrative_info = emp ? emp.administrative_info : null;
          e.job_info = emp.job_info ? emp.job_info : [];
          e.name_filter = emp.administrative_info ? emp.administrative_info.name.full_name.toLowerCase(): null;
          e.avt = emp.image_id ? ExtensionService.urlImg + emp.image_id + "&r=square&w=512"
            : emp.administrative_info && emp.administrative_info.avatar_id
            ? ExtensionService.urlImg + emp.administrative_info.avatar_id + "&r=square&w=512"
            : "";
          e.job_info = MethodService.getValidJobInfo(e.job_info, this.mData.dataDefault.listContractTypeId);
          let pos = '';
          if (e.job_info.length > 0) {
            pos = this.mData.dataDefault.listPosition.find(
              (position) => position.id == e.job_info[0].position_id
            );
          }
          e.position_name = pos ? pos.name : "";
          e.employee_no = emp ? emp.employee_no : "---";
          e.value = false;
        }
      });
      return data;
    },

    async getListDepartermentByCompanyUser() {
      const resApi = await DepartmentApi.list({
        filters: `disabled!=true`,
        fields: "id,name",
        limit: 1000,
      })
      if (resApi.result.length == 1) this.mData.dataForm.publish.department_id = resApi.result[0].id
      this.listDepaterments = resApi.result
    },

    checkTab(docType) {
      return  docType == 'FILTER' ? 'TatCa' :
              docType == 'DOC_IN' ? 'VanBanDen' :
              docType == 'DOC_SIGN_CONSENT' ? 'KyDuyet' :
              docType == 'DOC_SIGN_TEMP' ? 'KyNhay' :
              docType == 'DOC_OUT' ? 'VanBanDi' :
              docType == 'DOC_SIGN' ? 'TrinhKy' :
              docType == 'DOC_ORGANIZATIONMODEL' ? 'CayThuMuc' :
              docType == 'DOC_ISSUE' || docType == 'SIGNED' ? 'ChoBanHanh' : ''
    },

    fn_eventBus(tabName, type, nameDoc) {
      EventBus.$emit('breadCrumb', this.setDataBreadCrumd(tabName, type, nameDoc))
    },

    setDataBreadCrumd(tabName, type, nameDoc) {
      if (tabName == 'VanBanDen') {
        this.breadCrumb[2] = {
          name: 'Văn bản đến',
          path: `${
            type != 'list' && type != 'new' ? '/admin/DocumentsGeneral?tab=VanBanDen' : ''
          }`
        }
      } else if (tabName == 'VanBanDi') {
        this.breadCrumb[2] = {
          name: 'Văn bản đi',
          path: `${
            type != 'list' && type != 'new' ? '/admin/DocumentsGeneral?tab=VanBanDi' : ''
          }`
        }
      } else if (tabName == 'KyDuyet') {
        this.breadCrumb[2] = {
          name: 'Ký duyệt',
          path: `${
            type != 'list' && type != 'new' ? '/admin/DocumentsGeneral?tab=KyDuyet' : ''
          }`
        }
      } else if (tabName == 'KyNhay') {
        this.breadCrumb[2] = {
          name: 'Ký nháy',
          path: `${
            type != 'list' && type != 'new' ? '/admin/DocumentsGeneral?tab=KyNhay' : ''
          }`
        }
      } else if (tabName == 'TrinhKy') {
        this.breadCrumb[2] = {
          name: 'Trình ký',
          path: `${
            type != 'list' && type != 'new' ? '/admin/DocumentsGeneral?tab=TrinhKy' : ''
          }`
        }
      } else if (tabName == 'ChoBanHanh') {
        this.breadCrumb[2] = {
          name: 'Chờ ban hành',
          path: `${
            type != 'list' && type != 'new' ? '/admin/DocumentsGeneral?tab=ChoBanHanh' : ''
          }`
        }
      } else if (tabName == 'CayThuMuc') {
        this.breadCrumb[2] = {
          name: 'Cây thư mục',
          path: `${
            type != 'list' && type != 'new' ? '/admin/DocumentsGeneral?tab=CayThuMuc' : ''
          }`
        }
      } else if (tabName == 'TatCa') {
        this.breadCrumb[2] = {
          name: 'Tất cả',
          path: `${
            type != 'list' && type != 'new' ? '/admin/DocumentsGeneral?tab=TatCa' : ''
          }`
        }
      } else {
        this.breadCrumb[2] = {
          name: 'Thêm văn bản mới',
          path: ""
        }
      }
      if (type == 'list' || type == 'new') return this.breadCrumb
      if (this.breadCrumb.length == 3) {
        this.breadCrumb.push({
          name: `
            ${
              type == 'detail' ? 'Chi tiết' :
              type == 'sign' ? 'Ký duyệt' :
              type == 'promulgate' ? 'Ban hành' :
              type == 'transfer' ? 'Chuyển tiếp' :
              type == 'sign-request' ? 'Trình ký' :
              type == 'request-sign-temp' ? 'Yêu cầu ký nháy' : ''
            } ${nameDoc ? `'${nameDoc}'` : ''}
          `,
          path: ""
        })
      } else {
        this.breadCrumb[3] = {
          name: `
          ${
            type == 'detail' ? 'Chi tiết' :
            type == 'sign' ? 'Ký duyệt' :
            type == 'promulgate' ? 'Ban hành' :
            type == 'transfer' ? 'Chuyển tiếp' :
            type == 'sign-request' ? 'Trình ký' :
            type == 'request-sign-temp' ? 'Yêu cầu ký nháy' : ''
          } ${nameDoc ? `'${nameDoc}'` : ''}
          `,
          path: ""
        }
      }
      return this.breadCrumb
    },
  },
}
